import {Component} from '@angular/core';
import {environment} from 'src/environments/environment';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [TranslatePipe],
})
export class FooterComponent {
  externalUrl = environment.baseUrl;
}
